<template>
  <b-modal
    ref="modal"
    size="xl"
    hide-footer
    title="Alta de Chips"
    @hidden="reset"
  >
    <form v-promise-btn="{ action: 'submit' }" @submit.prevent="submit">
      <div class="container h-100">
        <div class="row">
          <div class="col">
            <div
              class="d-flex justify-content-center align-items-center"
              v-if="!file"
            >
              <input
                type="file"
                id="fileUpload"
                ref="file"
                style="display: none"
                @change="addFileFromExplorer"
              />
              <label for="fileUpload" style="width: 100%">
                <div
                  :class="`drop-zone${isDragging ? ' dragging' : ''}`"
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                  "
                  @drop.prevent="handleFileDropped"
                  @dragover.prevent="setDraggingOver(true)"
                  @dragleave="setDraggingOver(false)"
                >
                  <h3>Arrastre hacia aqui su archivo de Excel</h3>
                  <div>
                    <table
                      class="table table-sm table-condensed table-bordered"
                    >
                      <thead>
                        <tr>
                          <td>numero</td>
                          <td>IMSI</td>
                          <td>empresa</td>
                          <td>ubicación</td>
                          <td>plan</td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </label>
            </div>
            <div
              class="d-flex justify-content-center align-items-center"
              v-else
            >
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th v-for="header in headers" :key="header">
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, idx) in values" :key="value.id">
                    <td>{{ idx + 2 }}</td>
                    <td v-for="key in headers" :key="key">
                      {{ value[key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-flex justify-content-end">
        <button type="button" class="btn btn-danger" @click="closeModal">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import XlsHelpers from "@/pages/Avl/ABM/XlsHelpers";
import XLSX from "xlsx/xlsx";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "AltaDeChips",
  mixins: [XlsHelpers],
  data: () => ({
    isDragging: false,
    file: null,
    headers: [],
    values: [],
    checkingProblems: false,
    problemsEncountered: null,
  }),
  methods: {
    async submit() {
      const fd = new FormData();
      fd.append("chips", JSON.stringify(this.values));

      return axios.post("/chips", fd).then((response) => {
        let data = response.data;

        if (data.ok) {
          this.$refs.modal.hide();
          this.$bvToast.toast(data.message, {
            variant: "success",
          });
          this.$parent.onGridReady();
        } else {
          Swal.fire({
            icon: "error",
            title: "Se canceló la operación...",
            html: data.message,
          });
        }
      });
    },
    reset() {
      this.file = null;
      this.isDragging = false;
      this.headers = [];
      this.values = [];
    },
    closeModal() {
      this.$refs.modal.hide();
    },
    addFileFromExplorer(e) {
      console.log(e.target.files);
      this.handleFile(e.target.files[0]);
    },
    handleFileDropped(e) {
      this.setDraggingOver(false);
      console.log(e.dataTransfer.files[0]);
      this.handleFile(e.dataTransfer.files[0]);
    },
    handleFile(file) {
      this.file = file;
      let reader = new FileReader();
      reader.onload = (e) => {
        let results,
          data = e.target.result,
          fixedData = this.fixdata(data),
          workbook = XLSX.read(btoa(fixedData), { type: "base64" }),
          firstSheetName = workbook.SheetNames[0],
          worksheet = workbook.Sheets[firstSheetName];
        this.headers = this.get_header_row(worksheet);
        results = XLSX.utils.sheet_to_json(worksheet);
        this.values = results;
      };
      reader.readAsArrayBuffer(file);
    },
    setDraggingOver(value) {
      this.isDragging = value;
    },
  },
};
</script>

<style scoped>
.drop-zone {
  height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed lightblue;
  cursor: pointer;
}

.drop-zone.dragging {
  border: 10px dashed orange;
  background: darkorange;
}
</style>
